@if (resolved(); as resolved) {
	<section class="explanation">
		<span class="explanation__title">{{ I18N_KEY + '.TITLE' | translate }}</span>
		<div class="explanation__cards">
			<div class="explanation__card">
				<span class="explanation__label explanation__label--first">{{ I18N_KEY + '.LABELS.FIRST' | translate }}</span>
				@if (resolved.first) {
					<p class="explanation__text">{{ resolved.first }}</p>
				} @else {
					<p class="explanation__text explanation__text--placeholder">{{ I18N_KEY + '.PLACEHOLDER' | translate }}</p>
				}
			</div>
			<div class="explanation__card">
				<span class="explanation__label explanation__label--edges">{{ I18N_KEY + '.LABELS.EDGES' | translate }}</span>
				@if (resolved.edges) {
					<ul class="explanation__list">
						@for (edge of resolved.edges; track edge) {
							<li class="explanation__text">{{ edge }}</li>
						}
					</ul>
				} @else {
					<p class="explanation__text explanation__text--placeholder">{{ I18N_KEY + '.PLACEHOLDER' | translate }}</p>
				}
			</div>
			<div class="explanation__card">
				<span class="explanation__label explanation__label--recurring">{{ I18N_KEY + '.LABELS.RECURRING' | translate }}</span>
				@if (resolved.recurring) {
					<p class="explanation__text">{{ resolved.recurring }}</p>
				} @else {
					<p class="explanation__text explanation__text--placeholder">{{ I18N_KEY + '.PLACEHOLDER' | translate }}</p>
				}
			</div>
		</div>
		<p class="explanation__footer">{{ I18N_KEY + '.FOOTER' | translate }}</p>
	</section>
}
